import { Component } from '@angular/core';

@Component({
  selector: 'app-report-icon',
  templateUrl: './report-icon.component.html',
})
export class ReportIconComponent {

}
